define.alias("shared/components/shared/post/secondary/caption-writer/footer", "calendar/components/shared/post/secondary/caption-writer/footer");